#import "../../../editions/a-b-testing/graphql/fragments/comparison-edition-fragment.graphql"
#import "../../../editions/a-b-testing/graphql/fragments/comparison-fragment.graphql"
#import "./campaign-fragment.graphql"

fragment EditionStubFragment on Edition {
    id
    name
    htmlUrlPath
    viewInBrowserLink
    creatorUser {
        id
        name
    }
    createdTime
    modifiedTime
    deletedTime
    backgroundColor
    campaign {
        ...CampaignFragment
    }
    status
    emailTemplate {
        id
        thumbnailUrl
        subject
        previewText
        modifiedTime
        beeBodyJson
        links {
            url {
                id
                fullyQualifiedUrl
            }
        }
    }
    engagementStats {
        totalSentCount
        openRate
        clickRate
        unsubscribeRate
        permanentBounceRate
    }
    sendTime
    scheduledTime
    isABTesting
    comparisonEdition {
        ...ComparisonEditionFragment
    }
    comparison {
        ...ComparisonFragment
    }
    audience {
        id
        name
    }
    from {
        id
        emailAddress {
            display
            formatted
        }
    }
    delay {
        unit
        timespan
    }
    engagementStats {
        unsubscribeCount
        unsubscribeRate
        permanentBounceCount
        dripProgressionsGoalMet
        dripProgressionsGoalMetRate
    }
    emailTemplate {
        id
        links {
            link
            numTimesSent
            numTotalClicks
            numUniqueClicks
        }
    }
}
